<template>
  <main class="main" id="main">
    <div class="top_line">
      <div class="container work_box">
        <h1 class="work">Доставка осетинских пирогов</h1>
      </div>
    </div>
    <section class="section s-about_franchise">
      <div class="container">
        <div class="description_box">
          <div class="item">
            <p style="margin-top:2%;">Осетинские пироги – это любимое домашнее лакомство, которое нравится и взрослым, и детям. Подходит как для простого и сытного перекуса, так и для праздничного застолья. Большое разнообразие начинок  у осетинских пирогов не оставляет равнодушным заядлых мясоедов, любителей овощей и даже сладкоежек.</p>
            <h2 style="margin-top:2%;">История</h2>
            <p>Как же вообще появились осетинские пироги? Эти лепешки получили широкую известность во времена татаро-монгольских нашествий. Из – за частых нашествий коренному населению «Аланы» (нынешняя Осетия) пришлось уйти подальше в горы. Населению нужна была еда, приготовленная из простых ингредиентов, сытная и вкусная. Тогда – то и пришла мысль о создании аппетитной лепешки, наполненной мясом, молочными продуктами, овощами и всевозможной зеленью.</p>
            <p>&nbsp;</p>
            <center><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/global/articles/caucasian2.jpg" alt="Осетинские пироги"  width="700" /></center>
            <h2 style="margin-top:2%;">Особенность названия. Что связывает его с начинкой?</h2>
            <p>Несмотря на общее название «осетинский пирог», его переименовывают, в зависимости от начинки, добавляя суффикс «джын». Самые популярные и востребованные пироги:</p>
            <p style="margin-top:2%;"></p>
            <ul>
              <li>«Даводжин» - с листьями черемши и национальным сыром;</li>
              <li>«Кабускаджин» - с перетертыми листьями капусты и сыром;</li>
              <li>«Картофджин» - с сыром и картошкой;</li>
              <li>«Насджин» - с тыквой;</li>
              <li>«Уалибах» и «Хабизджин» - круглый вариант с сыром;</li>
              <li>«Артадзыхон» - треугольный вариант с сыром;</li>
              <li>«Фыдджин» - с `
                измельченным мясом;</li>
              <li>«Кадурджин» - с фасолью;</li>
              <li>«Кадындзджин» - с сыром и зеленым луком;</li>
              <li>«Зокоджин» - с грибами.</li>
            </ul>
            <p style="margin-top:2%;">Названия всех пирогов запоминать, конечно же, не стоит. Но рассказать, хотя бы вкратце, о некоторых нам бы хотелось. Итак, начнём.</p>
            <p style="margin-top:2%;"><b>«Даводжин»</b></p>
            <p>Аппетитный пирог из листьев черемши и сыром. Черемша – не просто растение, обладающее слегка кисловатым вкусом. Прежде всего, это трава, которая способствует укреплению иммунитета.  А ещё плюс этого пирога в том, что готовиться он всего 20 минут. Поэтому, заказывая его, Вы можете быть уверены, что на вашем столе он окажется очень скоро.</p>
            <p style="margin-top:2%;"><b>«Фэдкуджын»</b></p>
            <p>Этот вид пирога очень сильно напоминает штрудель. Корица и яблоко дополняют друг друга, образуя новый фантастический вкус, знакомый нам с детства.</p>
            <p style="margin-top:2%;"><b>«Кадурджин»</b></p>
            <p>Кадурджин готовится из красной молодой фасоли и грецких орехов. Начинка напоминает пхали из фасоли. Пикантности пирогу добавляет свежая кинза.</p>
            <p style="margin-top:2%;"><b>«Балджин»</b></p>
            <p>А этот вариант пирога готовится из свежей или замороженной вишни. Слегка кисловатый вкус идеально подойдёт на лето. С чаем и шариком ванильного мороженого будет самое то!</p>
            <p>Итак, это были самые запоминающиеся и необычные виды осетинских пирогов. Но какие бы они не были вкусные, увлекаться ими не стоит. Калорийность этой вкуснятины хоть и небольшая (около 200 ккал на 100 грамм), но тесто, приготовленное на кефире да ещё с добавлением дрожжей ничем хорошим не грозит. Как многим уже известно, вред от выпечки заключается именно в дрожжах. Поэтому раз в два месяца можно побаловаться, но не стоит забывать о здоровье.</p>
            <h2 style="margin-top:2%;">Заказ пирогов </h2>
            <p>Заказать осетинские пироги можно в любом грузинском ресторане или ресторане кавказской кухни. Еще  существуют заведения, которые специализируются непосредственно на пирогах. Поэтому выбор у Вас большой. Пробуйте и решайте, какие из всех видов самые вкусные, и где готовят лучшие лепёшки!</p>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'osetinian'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/articles/osetinian.vue